var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('project-documents',{ref:"project_drawings",attrs:{"type-document":'documents'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }